import { Table } from 'components/Table';
import { PerformanceReturnDetails } from 'types/PerformanceReturns';
import { getColumns, getData } from './PerformanceReturnDetailsUtil';

type Props = {
  data?: PerformanceReturnDetails;
  isLoading?: boolean;
};

export function PerformanceTable({ data, isLoading }: Props) {
  function getRowProps(row: any) {
    if (row?.values?.['returnComponent.name'].startsWith('Total')) {
      return {
        className: 'total',
      };
    } else {
      return {};
    }
  }
  return (
    <Table
      isLoading={isLoading}
      data={getData(data) ?? []}
      columns={getColumns(data?.benchmark?.typeId)}
      rowProps={getRowProps}
    />
  );
}
